// src/components/more/Growth.js
import React, { useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import { useAtom } from 'jotai';
import { useRequestProcessor } from '../../../requestProcessor';
import { activeChildDetail, GrowthAtom } from '../../../atomstore/store';
import SpinnerLoading from '../../common/SpinnerLoading';
import { fetchMeasurement } from '../../../queryfunctions/queryfunctions';
import MeasurementTab from './MeasurementTab';
import DevelopmentTab from './DevelopmentTab';
import { useNavigate } from 'react-router-dom';

const Growth = () => {
    const navigate = useNavigate();
    const [growthTab, setGrowthTab] = useState('measurements');
    const [measurements, setMeasurements] = useAtom(GrowthAtom);
    const [activeChild] = useAtom(activeChildDetail);

    const { useQueryWrapper } = useRequestProcessor();

    // Fetch measurements
    const { isLoading, isFetching } = useQueryWrapper(
        ['measurements', activeChild?.id],
        () => fetchMeasurement(),
        {
            onSuccess: (data) => {
                console.log('[Growth] Measurements response:', data);
                setMeasurements(data);
            },
        }
    );

    return (
        <div className="fixed inset-0 bg-gray-50 z-50 overflow-y-auto">
            {/* Header */}
            <div className="sticky top-0 bg-white border-b p-4 flex items-center space-x-3">
                <button onClick={() => navigate(-1)}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800 cursor-pointer" onClick={() => navigate(-1)}>Growth Tracker</h2>
            </div>

            {/* Tabs */}
            <div className="bg-white border-b sticky top-14 z-10">
                <div className="flex px-4 pt-4">
                    {[
                        { id: 'measurements', label: 'Measurements' },
                        { id: 'development', label: 'Development' },
                    ].map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setGrowthTab(tab.id)}
                            className={`flex-1 pb-3 text-sm font-semibold transition ${growthTab === tab.id
                                ? 'text-cyan-500 border-b-2 border-cyan-500'
                                : 'text-gray-400'
                                }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Tab Content */}
            <div className="p-4 space-y-4">
                {isLoading || isFetching ? (
                    <SpinnerLoading />
                ) : growthTab === 'measurements' ? (
                    <MeasurementTab measurements={measurements} />
                ) : (
                    <DevelopmentTab />
                )}
            </div>
        </div>
    );
};

export default Growth;
